
import { defineComponent, onMounted, ref, getCurrentInstance } from 'vue';
import { sendLog } from '@/common/radar';


export default defineComponent({
  components: {
  },
  props: {
    data: {
      type: Object,
      default: () => { }
    },
    muted: {
      type: Boolean,
      default: true
    },
    cardType: {
      type: String,
      default: 'photo_card'
    }
  },
  setup(props, ctx) {
    const { proxy } = getCurrentInstance() as { proxy: any }
    const isOpenButton = ref(true)
    const setUnMuted = () => {
      sendLog({
        type: 'click',
        name: 'PHOTO_CARD_SPECIAL',
        value: {
          button_type: 'muted',
          card_type: props.cardType
        }
      })
      proxy.$bus.emit('setMuted', false)

    }
    onMounted(() => {
      setTimeout(() => {
        isOpenButton.value = false
      }, 3000)
    })
    return {
      isOpenButton,
      setUnMuted
    };
  },
});

